export const DEMO_PROFILES = [
  { _id: '1', name: 'Priya', age: 24, dob: '2002-03-15', gender: 'female', city: 'Indore', distance: 3,
    bio: 'Coffee enthusiast | Weekend traveler | Dog mom 🐕',
    photos: ['https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&h=800&fit=crop'],
    interests: ['Music', 'Travel', 'Coffee', 'Photography'], isVerified: true, isPremium: true,
    compatibility: 94, profession: 'UX Designer', education: 'IIT Indore',
    prompts: [{ q: 'My perfect Sunday is...', a: 'Exploring a new cafe, long drive, and sunset photography' }],
    relationshipGoal: 'Serious Relationship', online: true },
  { _id: '2', name: 'Ananya', age: 23, dob: '2003-07-22', gender: 'female', city: 'Bhopal', distance: 8,
    bio: 'Architect by day, dancer by night 💃',
    photos: ['https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=600&h=800&fit=crop'],
    interests: ['Dance', 'Art', 'Food', 'Fashion'], isVerified: true, isPremium: false,
    compatibility: 87, profession: 'Architect', education: 'SPA Bhopal',
    prompts: [{ q: 'The quickest way to win me over...', a: 'Take me to a rooftop restaurant with a view' }],
    relationshipGoal: 'Long-term Partner', online: false },
  { _id: '3', name: 'Neha', age: 25, dob: '2001-11-08', gender: 'female', city: 'Pune', distance: 12,
    bio: 'Bookworm | Yoga lover | Cat person 🐱',
    photos: ['https://images.unsplash.com/photo-1517841905240-472988babdf9?w=600&h=800&fit=crop'],
    interests: ['Books', 'Yoga', 'Movies', 'Nature'], isVerified: false, isPremium: true,
    compatibility: 82, profession: 'Data Scientist', education: 'NIT Nagpur',
    prompts: [{ q: 'I get excited about...', a: 'Finding a book I can\'t put down and cozy rainy evenings' }],
    relationshipGoal: 'Serious Relationship', online: true },
  { _id: '4', name: 'Kavya', age: 22, dob: '2004-01-30', gender: 'female', city: 'Jaipur', distance: 5,
    bio: 'Startup founder | Fitness freak | Chai over coffee ☕',
    photos: ['https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=600&h=800&fit=crop'],
    interests: ['Fitness', 'Technology', 'Travel', 'Cooking'], isVerified: true, isPremium: false,
    compatibility: 91, profession: 'Entrepreneur', education: 'IIM Bangalore',
    prompts: [{ q: 'My biggest green flag is...', a: 'I always remember the little things people tell me' }],
    relationshipGoal: 'Still Exploring', online: true },
  { _id: '5', name: 'Riya', age: 26, dob: '2000-05-17', gender: 'female', city: 'Mumbai', distance: 15,
    bio: 'Fashion designer | Travel addict | Foodie 🌍',
    photos: ['https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=600&h=800&fit=crop'],
    interests: ['Fashion', 'Travel', 'Food', 'Music'], isVerified: true, isPremium: true,
    compatibility: 78, profession: 'Fashion Designer', education: 'NIFT Mumbai',
    prompts: [{ q: 'I\'m looking for...', a: 'Someone who can keep up with my travel plans and food cravings' }],
    relationshipGoal: 'Casual Dating', online: false },
  { _id: '6', name: 'Meera', age: 24, dob: '2002-09-12', gender: 'female', city: 'Hyderabad', distance: 20,
    bio: 'Classical dancer | Painter | Dog lover 🎨',
    photos: ['https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=600&h=800&fit=crop'],
    interests: ['Art', 'Dance', 'Nature', 'Photography'], isVerified: true, isPremium: false,
    compatibility: 85, profession: 'Art Director', education: 'JNTU Hyderabad',
    prompts: [{ q: 'A perfect first date...', a: 'Art gallery walk followed by street food exploration' }],
    relationshipGoal: 'Long-term Partner', online: true },
];

export const DEMO_MATCHES = [
  { _id: 'm1', user: { _id: '1', name: 'Priya', photos: ['https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop'] }, matchedAt: '2026-09-09T10:30:00Z', lastMessage: 'Hey! How was your weekend?', unread: 2 },
  { _id: 'm2', user: { _id: '4', name: 'Kavya', photos: ['https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&h=200&fit=crop'] }, matchedAt: '2026-09-08T15:00:00Z', lastMessage: 'That startup idea sounds amazing!', unread: 0 },
  { _id: 'm3', user: { _id: '6', name: 'Meera', photos: ['https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=200&h=200&fit=crop'] }, matchedAt: '2026-09-07T08:15:00Z', lastMessage: 'The art exhibition was incredible', unread: 1 },
];

export const DEMO_MESSAGES = {
  'm1': [
    { _id: 'msg1', sender: 'me', text: 'Hey Priya! Great to match with you 😊', time: '10:32 AM', read: true },
    { _id: 'msg2', sender: '1', text: 'Hey! Thanks! I noticed you like travel too', time: '10:35 AM', read: true },
    { _id: 'msg3', sender: 'me', text: 'Yes! I saw your photo from Manali, it was beautiful', time: '10:36 AM', read: true },
    { _id: 'msg4', sender: '1', text: 'Oh you saw that! That trip was so refreshing. We should plan a trip sometime!', time: '10:38 AM', read: true },
    { _id: 'msg5', sender: 'me', text: 'Definitely! What other places have you been to?', time: '10:40 AM', read: true },
    { _id: 'msg6', sender: '1', text: 'I have been to Himachal, Kerala, Rajasthan, and Goa. My dream is to visit Ladakh!', time: '10:42 AM', read: true },
    { _id: 'msg7', sender: '1', text: 'Hey! How was your weekend?', time: 'Yesterday', read: false },
  ],
  'm2': [
    { _id: 'msg8', sender: '4', text: 'Hey! I loved your profile. Fellow entrepreneur here!', time: '2:00 PM', read: true },
    { _id: 'msg9', sender: 'me', text: 'Hey Kavya! Nice to meet you. What does your startup do?', time: '2:05 PM', read: true },
    { _id: 'msg10', sender: '4', text: 'We are building a sustainable fashion platform. What about you?', time: '2:10 PM', read: true },
    { _id: 'msg11', sender: 'me', text: 'That sounds incredible! I am into ed-tech. Building something in the AI space.', time: '2:15 PM', read: true },
    { _id: 'msg12', sender: '4', text: 'That startup idea sounds amazing!', time: '3:00 PM', read: true },
  ],
  'm3': [
    { _id: 'msg13', sender: '6', text: 'Hi! Fellow art lover here 🎨', time: '11:00 AM', read: true },
    { _id: 'msg14', sender: 'me', text: 'Hey Meera! I saw your paintings on your profile, they are stunning!', time: '11:05 AM', read: true },
    { _id: 'msg15', sender: '6', text: 'The art exhibition was incredible', time: 'Yesterday', read: false },
  ],
};

export const DEMO_NOTIFICATIONS = [
  { _id: 'n1', type: 'like', user: 'Priya', photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop', time: '2m ago', read: false },
  { _id: 'n2', type: 'match', user: 'Kavya', photo: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop', time: '1h ago', read: false },
  { _id: 'n3', type: 'message', user: 'Meera', photo: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=100&h=100&fit=crop', text: 'The art exhibition was incredible', time: '3h ago', read: false },
  { _id: 'n4', type: 'superlike', user: 'Ananya', photo: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=100&h=100&fit=crop', time: '5h ago', read: true },
  { _id: 'n5', type: 'like', user: 'Neha', photo: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100&h=100&fit=crop', time: '1d ago', read: true },
];

export const EXPLORE_CATEGORIES = [
  { id: 'trending', label: 'Trending', icon: '🔥', color: '#EF4444' },
  { id: 'best_matches', label: 'Best Matches', icon: '❤️', color: '#FF3D71' },
  { id: 'nearby', label: 'Nearby', icon: '📍', color: '#22C55E' },
  { id: 'music', label: 'Music Lovers', icon: '🎵', color: '#8B5CF6' },
  { id: 'travel', label: 'Travel Lovers', icon: '✈️', color: '#3B82F6' },
  { id: 'coffee', label: 'Coffee Lovers', icon: '☕', color: '#F59E0B' },
  { id: 'new', label: 'New Members', icon: '🌟', color: '#EC4899' },
];

export const VIBE_OPTIONS = [
  { id: 'coffee', label: 'Coffee Date', icon: '☕', color: '#F59E0B' },
  { id: 'movie', label: 'Movie Night', icon: '🍿', color: '#8B5CF6' },
  { id: 'travel', label: 'Travel Partner', icon: '✈️', color: '#3B82F6' },
  { id: 'dinner', label: 'Dinner Date', icon: '🍽', color: '#FF3D71' },
  { id: 'talk', label: 'Just Talk', icon: '💬', color: '#22C55E' },
  { id: 'serious', label: 'Serious Connection', icon: '❤️', color: '#EC4899' },
  { id: 'adventure', label: 'Adventure', icon: '🔥', color: '#EF4444' },
];

export const INTERESTS = [
  'Music', 'Travel', 'Movies', 'Fitness', 'Gaming', 'Food', 'Coffee', 'Photography',
  'Technology', 'Fashion', 'Sports', 'Books', 'Art', 'Dance', 'Cooking', 'Yoga',
  'Nature', 'Shopping', 'Comedy', 'Meditation', 'Wine', 'Hiking', 'Pets', 'Anime'
];

export const RELATIONSHIP_GOALS = [
  { id: 'serious', label: 'Serious Relationship', icon: '💕', desc: 'Looking for something meaningful' },
  { id: 'longterm', label: 'Long-term Partner', icon: '💑', desc: 'Ready to commit' },
  { id: 'casual', label: 'Casual Dating', icon: '🌸', desc: 'Going with the flow' },
  { id: 'friendship', label: 'Friendship', icon: '🤝', desc: 'Open to new connections' },
  { id: 'exploring', label: 'Still Exploring', icon: '🧭', desc: 'Not sure yet, let us see' },
];
